//
//
//
//
//
//
//
//

import { dragMoveAction1 } from '@/common/utils/drag.js'
export default{
  data() {
    return {

    }
  },
  created() {
    this.$nextTick(() => {
      dragMoveAction1('LiveChatDrag')
    })
  },
  methods: {
    openChat() { // 打开聊天
      if (window.LiveChatWidget) {
        window.LiveChatWidget.call('maximize')
      } else {
        // window.open(this.FrontConfigList.customer_service_system_link, '_bank')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build821/views/components/contact-way/index.vue